import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { CAPABILITIES } from "@/data/site";
import { Plus } from "lucide-react";

export default function Capabilities() {
  return (
    <section id="capabilities" data-testid="capabilities-section" className="relative py-28 lg:py-40 border-t border-border">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-16">
          <div>
            <Reveal>
              <span className="font-mono text-xs tracking-[0.35em] text-primary uppercase">02 — What We Do</span>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-5 font-display font-medium text-4xl lg:text-7xl tracking-tight leading-none">
                Capabilities
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <p className="max-w-sm text-muted-foreground text-base">
              End-to-end metal manufacturing — engineered for tight tolerances and repeatable quality.
            </p>
          </Reveal>
        </div>

        <div className="grid lg:grid-cols-6 gap-5 auto-rows-[minmax(220px,auto)]">
          {CAPABILITIES.map((c, i) => (
            <Reveal key={c.id} delay={i * 0.08} className={c.span}>
              <motion.div
                whileHover={{ y: -6 }}
                transition={{ duration: 0.3 }}
                className="group relative h-full min-h-[220px] border border-border overflow-hidden bg-card"
                data-testid={`capability-card-${c.id}`}
              >
                <div className="absolute inset-0">
                  <img
                    src={c.image}
                    alt={c.title}
                    className="w-full h-full object-cover opacity-40 group-hover:opacity-60 group-hover:scale-105 transition-all duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background via-background/70 to-transparent" />
                </div>
                <div className="relative z-10 h-full flex flex-col justify-between p-7">
                  <div className="flex items-center justify-between">
                    <span className="font-mono text-sm text-primary tracking-widest">{c.id}</span>
                    <Plus className="w-5 h-5 text-foreground/50 group-hover:text-primary group-hover:rotate-90 transition-all duration-300" />
                  </div>
                  <div>
                    <h3 className="font-display text-2xl lg:text-3xl font-semibold leading-tight">{c.title}</h3>
                    <p className="mt-3 text-sm text-muted-foreground max-w-md leading-relaxed">{c.desc}</p>
                  </div>
                </div>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
